import { useEffect, useRef } from 'react';
import { Button } from '@/ui/components/Button';
import { useTerms } from '../../hooks/useTerms';
import { useNavigate } from 'react-router-dom';
import styles from './PartnerTermsPage.module.scss';
import { PageLoader } from '@/layouts/components/PageLoader/PageLoader';
import { Icon } from '@/ui/icons/Icon';

function PartnerTermsPage() {
  const navigate = useNavigate();
  const { getPartnerTerms, partnerTerms, isLoading } = useTerms();
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    getPartnerTerms();
  }, []);

  useEffect(() => {
    if (!iframeRef.current || !partnerTerms) return;
    const doc = iframeRef.current.contentDocument;
    if (!doc) return;

    doc.body.innerHTML = partnerTerms;
    doc.body.style.setProperty('padding', '8px', 'important');
  }, [partnerTerms]);

  const handleContinue = () => {
    navigate(-1);
  };

  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.termsContainer}>
          <h1 className={styles.title}>
            Acordul pentru interogarea la Biroul de Credit și ANAF
          </h1>

          <iframe
            ref={iframeRef}
            className={styles.termsText}
            title="Partner Terms"
            sandbox="allow-same-origin"
          />
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <Button
          trackingId="accept_partner_terms"
          variant="filled"
          text="Continuă"
          className={styles.button}
          onClick={handleContinue}
          rightIcon={<Icon name="arrow-right" />}
        />
      </div>
    </div>
  );
}

export default PartnerTermsPage;
